import _extends from "@babel/runtime-corejs3/helpers/extends";
import { useInstance } from 'intact-vue-next';
import { createContext } from '../context';
import { hasDocumentAvailable, isObject, isNullOrUndefined } from 'intact-shared';
// import type * as EnquireJs from 'enquire.js';
import enquire from 'enquire.js';
import { useState } from '../../hooks/useState';
import { responsiveMap } from './constants';
// let enquire: typeof EnquireJs;
// if (hasDocumentAvailable) {
// enquire = require('enquire.js');
// }
export var context = createContext(0);
export function useGutter() {
  var instance = useInstance();
  var matches = useState({
    xxl: false,
    xl: false,
    lg: false,
    md: false,
    sm: false,
    xs: false
  });
  if (hasDocumentAvailable) {
    var _loop = function _loop(key) {
      enquire.register(responsiveMap[key], {
        match: function match() {
          var _instance$get = instance.get(),
            gutter = _instance$get.gutter;
          if (isObject(gutter)) {
            var _extends2;
            matches.set(_extends({}, matches.value, (_extends2 = {}, _extends2[key] = true, _extends2)));
          }
        },
        unmatch: function unmatch() {
          var _instance$get2 = instance.get(),
            gutter = _instance$get2.gutter;
          if (isObject(gutter)) {
            var _extends3;
            matches.set(_extends({}, matches.value, (_extends3 = {}, _extends3[key] = false, _extends3)));
          }
        }
      });
    };
    for (var key in responsiveMap) {
      _loop(key);
    }
  }
  function getGutter() {
    var _instance$get3 = instance.get(),
      gutter = _instance$get3.gutter;
    if (isObject(gutter)) {
      var _key;
      var lastFound = null;
      for (_key in responsiveMap) {
        var value = gutter[_key];
        if (!isNullOrUndefined(value)) {
          lastFound = value;
          if (matches.value[_key]) {
            return value;
          }
        }
      }
      // if the breakpoint has not value, use the closest breakpoint value instead of
      return lastFound;
    }
    return gutter;
  }
  return {
    getGutter: getGutter
  };
}
export function gutterStyle(gutter, style, prop) {
  var margin = gutter / 2;
  var sign = prop === 'margin' ? '-' : '';
  if (!style) style = '';
  if (typeof style === 'string') {
    style = "" + style + (!style || /;\s*$/.test(style) ? '' : ';') + prop + "-left: " + sign + margin + "px; " + prop + "-right: " + sign + margin + "px;";
  } else {
    var _extends4;
    style = _extends((_extends4 = {}, _extends4[prop + "Left"] = "" + sign + margin + "px", _extends4[prop + "Right"] = "" + sign + margin + "px", _extends4), style);
  }
  return style;
}